export default "__VITE_ASSET__B5yAvp7E__"